<template>
    <div>
        <div v-for="(countryData, countryName) in configData" :key="countryName" class="country-section">
            <div class="country-title">{{ countryName }}</div>
            <el-form ref="formData" :model="formData" label-width="200px" class="country-form">
                <el-form-item 
                    v-for="(item, key) in countryData" 
                    :key="key" 
                    :label="item.message + ':'"
                    class="inline-form-item">
                    <el-input-number
                        v-model="formData[key]"
                        style="width: 120px;"
                        :min="0.00"
                        :step="0.01"
                        size="mini"
                        :placeholder="'请输入' + item.message"
                    >
                    </el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <div style="width: 100%; margin-top: 20px;">
            <el-button style="margin: auto;display: block;" size="mini" type="primary" @click="submitForm()"
                       :loading="loading">修改
            </el-button>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {
    manager_index_get_cost_control_message,
    manager_index_update_cost_control_message
} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {},
    data() {
        return {
            loading: false,
            formData: {},
            configData: {} // 存储原始配置数据用于渲染
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.getControlMessage()
    },
    methods: {
        getControlMessage() {
            this.loading = true
            api.manager_index_get_cost_control_message().then(res => {
                if (res.code === 0) {
                    // 保存原始配置数据用于渲染
                    this.$set(this, 'configData', res.data)
                    
                    // 将嵌套的数据结构扁平化处理用于表单绑定
                    const flatData = {}
                    Object.keys(res.data).forEach(country => {
                        Object.keys(res.data[country]).forEach(key => {
                            flatData[key] = res.data[country][key].value
                        })
                    })
                    this.$set(this, 'formData', flatData)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 保存信息
        submitForm() {
            // 直接提交扁平化的数据（字段是动态的）
            this.loading = true
            api.manager_index_update_cost_control_message(this.formData)
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({message: '修改成功', type: 'success'})
                        this.getControlMessage() // 重新加载数据
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
                .catch(() => {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '网络出现问题，请刷新页面！'
                    })
                })
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}

.country-section {
    margin-bottom: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    background-color: #fff;
}

.country-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    padding: 10px;
    margin-bottom: 15px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    text-align: center;
}

.country-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.inline-form-item {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
}
</style>
